<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur pharmaceutique' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur pharmaceutique' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'Le secteur pharmaceutique' | translate}}</span> {{ 'développe, produit et diffuse des médicaments. Il est en lien direct avec la santé physique et mentale de l’être humain et a une place primordial dans la vie de chaque individu.' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global pharmaceutical sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States pharmaceutical sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French pharmaceutical sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'En 2019, 10 personnes sont mortes en Chine après un incendie dans une usine pharmaceutique.' | translate}} <a class="source" href="https://www.hazardexonthenet.net/article/170482/10-killed-in-fire-at-pharmaceutical-plant-in-China.aspx" target="_blank" rel="noopener nofollow" title="hazardexonthenet">{{'(source)' | translate}}</a></li>
                      <li>{{'La plupart des décès signalés sont survenus en 2018 et 2019. 83 % des décès sont survenus en Chine et en Inde.' | translate}} <a class="source" href="https://www.sciencedirect.com/science/article/pii/S0950423020305660?dgcid=rss_sd_all&utm_source=researcher_app&utm_medium=referral&utm_campaign=RESR_MRKT_Researcher_inbound" target="_blank" rel="noopener nofollow" title="sciencedirect">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'La valeur de l’industrie pharmaceutique mondiale atteindra 1 500 milliards de dollars en 2023.' | translate}} <a class="source" href="https://www.healtheconomics.com/industry-news/report-global-pharma-market-to-surpass-1-5-trillion-by-2023" target="_blank" rel="noopener nofollow" title="healtheconomics">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'1,6 personne pour 100 travailleurs à temps plein a souffert de blessures et de maladies non mortelles ' | translate}}<a class="source" href="https://www.bls.gov/web/osh/summ1_00.htm#soii_n17_as_t1.f.1" target="_blank" rel="noopener nofollow" title="bls">{{'(source)' | translate}}</a></li>
                    <li>{{'L’accident le plus désastreux a eu lieu en 2003 avec l’explosion de West Pharmaceutical Services (Caroline du Nord). Au total, six personnes ont été tuées.' | translate}} <a class="source" href="https://en.wikipedia.org/wiki/West_Pharmaceutical_Services_explosion" target="_blank" rel="noopener nofollow" title="wikipedia">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'L’industrie pharmaceutique des États-Unis est la plus importante au monde en terme de développement et de production de médicaments. 5 des 10 principales entreprises pharmaceutiques (sur la base du chiffre d’affaires) ont leur siège aux États-Unis.' | translate}} <a class="source" href="https://www.pharmapproach.com/15-astonishing-statistics-and-facts-about-u-s-pharmaceutical-industry/" target="_blank" rel="noopener nofollow" title="pharmapproach">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Le secteur chimie-pharmacie a recensé 170 accidents en France en 2018 ' | translate}}<a class="source" href="https://www.usinenouvelle.com/article/reperes-de-plus-en-plus-d-accidents-sur-les-sites-seveso.N891679" target="_blank" rel="noopener nofollow" title="usinenouvelle">{{'(source)' | translate}}</a></li>
                    <li>{{'En France, de la fabrication à la commercialisation, le secteur pharmaceutique a enregistré 187 990 jours d’incapacité temporaire dus à des accidents du travail (2017).' | translate}}</li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'Près de 100’000 salariés sont directement employés par les entreprises du médicament en France en 2018.' | translate}} <a class="source" href="https://www.leem.org/lindustrie-pharmaceutique-en-france-emploi-et-localisation" target="_blank" rel="noopener nofollow" title="leem">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p>{{ 'La formation des travailleurs pharmaceutiques est essentielle pour leur sécurité contre les accidents, ainsi que pour la santé publique afin de garantir le respect des normes.' | translate}}</p>
    </div>
    <div class="row pt-2">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'S’adapter aux pandémies' | translate}}</p>
                <p class="text-justify">{{'La crise de la Covid-19 à significativement mis en lumière l’importance du secteur pharmaceutique, à la fois au niveau de la chaîne de production que de l’approvisionnement et de la R&D. Une réponse à la fois efficace et rapide est primordiale dans le secteur.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plateforme clé en main qui fait gagner du temps sur les aspects d’organisation de journées sécurité, ' | translate }} <a class="source" [routerLink]="language.navigateAccordingToLang(['/blog/131-Quart-dheure-sécurité-les-avantages-de-limmersive-learning'])" target="_blank" rel="noopener nofollow" title="15-minute safety meetings">{{'quarts d’heures sécurité' | translate}}</a>{{', de formations, etc. et qui permet un gain de temps lors de situation où l’efficacité est cruciale.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/campus-hall-people.webp" type="image/webp">
                <source srcset="assets/campus-hall-people.jpg" type="image/jpg">
                <img src="assets/campus-hall-people.jpg" class="block-rounded abstract-formation" alt="Immersive Factory Virtual Campus" title="Virtual Campus" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal_V2.jpg" class="block-rounded abstract-formation" alt="Website backoffice: reporting and statistics" title="Back-office" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Respect et sécurisation des normes' | translate}}</p>
                <p class="text-justify">{{'La sécurité interne (employé) et externe (consommateur) est un enjeu humain décisif. Des normes d’hygiène importantes et nécessaires : stérilisation des procédés, port de vêtements spécifiques, procédés de fabrication stricts, limitation aux zones restreintes.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Outil personnalisable permettant la cohérence des actions pour une compréhension collective et individuelle des normes à respecter. Le back office intuitif et l’accès des données en temps réel sur les indicateurs clés de performance (KPI) permet un suivi des efforts et des réalisations des équipes constant.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Se protéger contre les accidents' | translate}}</p>
                <p class="text-justify">{{'Un environnement et des opérations comportant des risques dangereux pour ses employés : manipulation de produits chimiques ou biologiques et de principes pharmaceutiques actifs (API), traitement de solides (broyage, mélange, granulation, séchage). Tous ces risques peuvent entraîner des intoxications (cutanées, respiratoires, etc.), des blessures physiques (brûlures, contusions, etc.), des explosions (dues à la manipulation, au stockage ou au transport). Les accidents sont parfois chroniques et irréversibles pour les employés.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Catalogue de plus de 30 exercices en apprentissage immersif permettant un apprentissage plus rapide et plus efficace que les formations classiques pour réduire efficacement le nombre d’accidents.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'pharma-proteger-accidents' | translate}}.png" type="image/png">
                <img src="assets/{{'pharma-proteger-accidents' | translate}}.png" class="block-rounded" alt="VR training workshops increase learner memory by 4" title="VR trainings" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/multi_supports.webp" type="image/webp">
                <source srcset="assets/multi_supports.jpg" type="image/jpg">
                <img src="assets/multi_supports.jpg" class="block-rounded abstract-formation" alt="Immersive Factory virtual campus is available on PC and Mac" title="Multi-support" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/4-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Une place accrue de la technologie' | translate}}</p>
                <p class="text-justify">{{'Les nouvelles technologies sont particulièrement utiles au secteur, notamment l’automatisation de la production qui réduirait les risques humains.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plateforme digitale immersive 3D & VR. L’aspect multi-device permettant à chaque apprenant de s’entraîner où qu’il se trouve.' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Adoptez les bons gestes avec Immersive Factory ?' | translate}}</span>
    </div>
    <div class="text-justify">
    	<p>{{"Immersive Factory propose aux entreprises du milieu pharmaceutique, un système de formations sur mesure pour permettre d’apprendre les gestes de sécurité, mais aussi l'apprentissage du respect des diverses normes et procédés nécessaires à la fabrication des produits pharmaceutiques et cosmétiques." | translate}}</p>
    	<p>{{"Outre la simplification de la mise en place des formations à la sécurité, journées sécurités et quarts d'heures sécurité, et l'augmentation de leur efficacité, nos modules vous permettent d'améliorer les formations aux employés sur l'entièreté de leurs diverses missions. Notre outil en réalité virtuelle augmente l'aspect pédagogique des formations, et s'adapte parfaitement à votre industrie grâce à une équipe d'experts et de techniciens formés au secteur de la production pharmaceutique." | translate }}</p>
    	<p class="mb-0">{{"Au cœur de notre métier, la formation à la production avec un focus sur la qualité des produits de pharmacie et cosmétique grâce à différents modules, outils et parcours adaptés et pratiques pour donner à vos équipes les moyens d'améliorer la qualité de leur travail et de permettre également d’assurer leur sécurité." | translate }}</p>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur les avantages des formations HSE en réalité virtuelle ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Découvrez les sept avantages de la formation HSE en réalité virtuelle dans cet article de blog :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="7 benefits of Virtual reality EHS training" title="VR EHS training" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>


<hr class="mt-5">

<section class="reassurance">
  <div class="container py-4 mb-4">
      <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
      <div class=" d-flex align-items-center justify-content-center flex-wrap" style="gap:30px">
           <picture *ngFor="let image of images;let i = index">
               <source srcset="{{image.url}}.webp" type="image/webp">
               <source srcset="{{image.url}}.png" type="image/png">
               <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" width="200px" loading="lazy">
           </picture>
      </div>
  </div>
</section>

<hr class="my-4">


<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur pharmaceutique' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<!-- TEMOIGNAGE CLIENT
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage Lorem Ipsum' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/{{'FR_Analyse_Critique_Modeles_Apprentissage.pdf' | translate}}" target="_blank">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
-->
